<script lang="ts">
	import type { TranslationKeys } from '$lib/server/translations/translations.service';
	import { translationsStore } from '$lib/store/translations.store';

	interface Props {
		errorCode?: keyof TranslationKeys | null;
		ipn?: any;
	}

	let { errorCode = null, ipn = '' }: Props = $props();
</script>

<div class="relative flex h-full w-full flex-col flex-wrap items-center justify-between sm:flex-row">
	<div class="flex h-full w-full flex-col items-center justify-center sm:w-1/2">
		<svg class="mb-12 block w-32">
			<use href="/assets/svgs/logo_mark.svg#logo_mark" />
		</svg>
		<!-- <img class="mb-12 block w-32" src="/assets/images/logo.jpg" alt="logo" /> -->
		<div class="text-main-dark relative flex justify-center pb-4 text-6xl">OOPS!</div>

		<div class="text-surface-light relative z-10 w-full max-w-sm px-2 text-center text-2xl leading-8 sm:mt-8 sm:px-0">
			{#if ipn}
				<p>
					{$translationsStore.planerror || 'There is an error on plan number'}
					<span class="text-secondary font-bold">{ipn}</span>
				</p>
			{/if}
			<p class="my-3">
				{#if errorCode && $translationsStore[errorCode]}
					{$translationsStore[errorCode]}
				{:else}
					{$translationsStore.genericerror || 'Unknown error has ocurred.'}
				{/if}
			</p>
			<p>
				{$translationsStore.gohome || "Let's go"}
				<a href="https://www.splitit.com/" class="text-blue">
					{$translationsStore.home || 'home'}
				</a>
				{$translationsStore.tryhome || 'and try from there.'}
			</p>
		</div>
	</div>
	<div class="left relative hidden min-h-[700px] w-1/2 sm:flex">
		<img class="absolute -bottom-12 -left-4 w-1/2 opacity-50" src="/assets/images/side-image-mask.jpeg" alt="mask" />
	</div>
</div>

<style>
	.left {
		background-image: url('/assets/images/left.jpg');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
	}
</style>
